import React from "react";
import { Globe } from "lucide-react";
import { Highlight } from "@multiagentbook/ui";
import { useTranslation, Trans } from "react-i18next";

export const AboutAuthors = () => {
  const { t } = useTranslation("home");
  const people = [
    {
      name: "Victor Dibia",
      role: "Principal Research Software Engineer, Microsoft Research",
      imageUrl: "/images/victordibia.webp",
      bio: (
        <Trans
          i18nKey="author.authorBioTrans"
          ns="home"
          components={{
            msr: <Highlight><a href="https://www.microsoft.com/en-us/research/people/victordibia/" target="_blank" rel="noreferrer" /></Highlight>,
            autogenstudio: <Highlight><a href="https://github.com/microsoft/autogen" target="_blank" rel="noreferrer" /></Highlight>,
            autogen: <Highlight><a href="https://github.com/microsoft/autogen" target="_blank" rel="noreferrer" /></Highlight>,
            lida: <Highlight><a href="https://github.com/microsoft/lida" target="_blank" rel="noreferrer" /></Highlight>,
          }}
        />
      ),
      xUrl: "https://twitter.com/vykthur",
      linkedinUrl: "https://www.linkedin.com/in/dibiavictor/",
      websiteUrl: "https://victordibia.com",
    },
  ];

  return (
    <div className="border-t border-secondary mt-20 pt-20">
      <div className="bg-primary ">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-20  xl:grid-cols-5">
          <div className="max-w-2xl xl:col-span-2">
            <h2 className="text-3xl font-bold tracking-tight  sm:text-4xl">
              {t("author.aboutTitle")}
            </h2>
            <p className="mt-6 text-lg leading-8 ">
              {t("author.aboutIntro")}
            </p>
          </div>
          <ul
            role="list"
            className="-mt-12 space-y-12 divide-y divide-gray-200 xl:col-span-3"
          >
            {people.map((person) => (
              <li
                key={person.name}
                className="flex flex-col gap-10 pt-12 sm:flex-row"
              >
                <img
                  alt=""
                  src={person.imageUrl}
                  className="aspect-[4/5] md:h-52 sm:h-52   w-64 sm:w-auto   flex-none rounded-lg object-cover"
                />
                <div className="max-w-xl flex-auto">
                  <h3 className="text-lg font-semibold leading-8 tracking-tight text-primary">
                    {person.name}
                  </h3>
                  <p className="text-base leading-7 ">{person.role}</p>
                  <p className="mt-6 text-base leading-7 ">{person.bio}</p>
                  <ul role="list" className="mt-6 flex gap-x-6">
                    <li>
                      <a
                        href={person.websiteUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="text-primary hover:text-secondary"
                      >
                        <span className="sr-only">Website</span>
                        <Globe className="h-5 w-5" />
                      </a>
                    </li>
                    <li>
                      <a
                        href={person.xUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="text-secondary hover:text-gray-500"
                      >
                        <span className="sr-only">X</span>
                        <svg
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                          className="h-5 w-5"
                        >
                          <path d="M11.4678 8.77491L17.2961 2H15.915L10.8543 7.88256L6.81232 2H2.15039L8.26263 10.8955L2.15039 18H3.53159L8.87581 11.7878L13.1444 18H17.8063L11.4675 8.77491H11.4678ZM9.57608 10.9738L8.95678 10.0881L4.02925 3.03974H6.15068L10.1273 8.72795L10.7466 9.61374L15.9156 17.0075H13.7942L9.57608 10.9742V10.9738Z" />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a
                        href={person.linkedinUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="text-primary hover:text-secondary"
                      >
                        <span className="sr-only">LinkedIn</span>
                        <svg
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                          className="h-5 w-5"
                        >
                          <path
                            d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                            clipRule="evenodd"
                            fillRule="evenodd"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutAuthors;
